;(function() {
  'use strict'

  angular.module('core.orgSelector', [])
})()
